import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HorizontalDistributeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"horizontal_distribute"}/>
}
